import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [CommonModule, LottieComponent],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.css',
})
export class PageNotFoundComponent {
  @Input() show = false;

  constructor(private router: Router) {

  }

  options: AnimationOptions = {
    path: 'assets/Animations/NotFound-404.json',
    loop: true,
    autoplay: true,
  };

  goToDashboard() {
    this.router.navigate(['/registered-users']); 
  }
}
